import {
  DomainModelHelper,
  EntityBase,
  RequestValidationError,
} from '@digital-platform/shared/domain';
import { SignNowDocument } from '../interfaces';
import { SignNowSubscription } from '../interfaces/subscription.interface';
import { DataItemType, SUPPORTED_TYPES } from '../types';
import { SignatureModel } from './signature.model';
import { SignNowSubscriptionModel } from './subscription.model';

export class SignNowDocumentModel
  extends EntityBase
  implements SignNowDocument
{
  constructor(config?: SignNowDocument) {
    super(config);
    this.id = config
      ? DomainModelHelper.ensureDataIsString(config?.id)
      : SignNowDocumentModel.DEFAULT_CONFIG.id;
    this.name = config
      ? DomainModelHelper.ensureDataIsString(config?.name)
      : SignNowDocumentModel.DEFAULT_CONFIG.name;
    this.url = config
      ? DomainModelHelper.ensureDataIsString(config?.url)
      : SignNowDocumentModel.DEFAULT_CONFIG.url;
    this.isComplete = config
      ? DomainModelHelper.ensureDataIsBoolean(config?.isComplete)
      : SignNowDocumentModel.DEFAULT_CONFIG.isComplete;

    this.signingLink = DomainModelHelper.ensureDataIsString(
      config?.signingLink
    );
    if (config?.viewLink !== undefined) {
      this.viewLink = DomainModelHelper.ensureDataIsString(config?.viewLink);
    }
    if (config?.signatures !== undefined) {
      this.signatures = config?.signatures?.map(
        (signature) => new SignatureModel(signature)
      );
    }
    if (config?.dataItem?.type !== undefined) {
      const parsed = DomainModelHelper.ensureDataIsString(
        config?.dataItem?.type
      );

      if (
        parsed !== null &&
        !(SUPPORTED_TYPES as readonly string[]).includes(parsed)
      ) {
        throw new RequestValidationError(
          `Unknown Data Item Type for Signature: ${parsed} - ${JSON.stringify(
            config
          )}`
        );
      }

      this.dataItem = {
        ...this.dataItem,
        type: parsed as DataItemType,
      };
    }
    if (config?.dataItem?.id !== undefined) {
      this.dataItem = {
        ...this.dataItem,
        id: DomainModelHelper.ensureDataIsString(config.dataItem.id),
      };
    }
    if (config?.dataItem?.version !== undefined) {
      this.dataItem = {
        ...this.dataItem,
        version: DomainModelHelper.ensureDataIsNumber(config.dataItem.version),
      };
    }
    if (config?.subscriptions !== undefined) {
      this.subscriptions = config.subscriptions.map(
        (subscription) => new SignNowSubscriptionModel(subscription)
      );
    } else {
      this.subscriptions = SignNowDocumentModel.DEFAULT_CONFIG.subscriptions;
    }
  }

  public static readonly DEFAULT_CONFIG: SignNowDocument = {
    id: '',
    name: '',
    url: '',
    isComplete: false,
    signingLink: null,
    viewLink: null,
    signatures: [],
    dataItem: {
      type: null,
      id: null,
      version: null,
    },
    subscriptions: [],
  };

  public readonly id: string;
  public readonly name: string;
  public readonly url: string;
  public readonly isComplete: boolean;
  public readonly signingLink?: string;
  public readonly viewLink?: string;
  public readonly signatures?: SignatureModel[];
  public readonly dataItem?: {
    readonly type: DataItemType;
    readonly id: string;
    readonly version: number;
  };
  public readonly subscriptions?: SignNowSubscription[];
}
